import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { PerformanceRecordRequest } from '@/types/performanceRecord';

export const updatePerformanceRecord = async (
  performanceRecordID: number,
  requestBody: PerformanceRecordRequest
): Promise<ApiResult<boolean>> => {
  const { status, result } = await callApi<boolean>(
    `performance-records/${performanceRecordID}`,
    'PUT',
    undefined,
    requestBody,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
